export const formatPhoneNumber = (number: string) => {
  if (!number) return;

  if (number.length === 9) {
    return `${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(6, 9)}`;
  } else if (number.length === 12) {
    return `${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(
      6,
      9
    )} ${number.slice(9, 12)}`;
  } else return number;
};
